module.exports = ".press_ct_blk {\n    background: transparent;\n}\n"